import { isUndNullEmp } from '../../helpers/main.js';

export class Device {
    constructor(
        _id = 0,
        _name = '',
        _label = '',
        _register = '',
    ) {
        this.id = _id;
        this.name = _name;
        this.label = _label;
        this.register = _register;
    }

    static getClassName = () => {
        return 'Device - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    //Id: 0,
                    Name: 2,
                    Label: 2,
                    Register: 10,
                },
                max: {
                    //Id: 0,
                    Name: 30,
                    Label: 50,
                    Register: 10,
                }
            };
        } else {
            return {
                min: {
                    //id: 0,
                    name: 2,
                    label: 2,
                    register: 10,
                },
                max: {
                    //id: 0,
                    name: 30,
                    label: 50,
                    register: 10,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new Device(
                    obj.Id,
                    obj.Name,
                    obj.Label,
                    obj.Register,
                );
            } else {
                return new Device(
                    obj.id,
                    obj.name,
                    obj.label,
                    obj.register,
                );
            }
        } else {
            return new Device();
        }
    }
}